import { render } from "./CajaList.vue?vue&type=template&id=5a43e5d0&scoped=true"
import script from "./CajaList.vue?vue&type=script&lang=js"
export * from "./CajaList.vue?vue&type=script&lang=js"

import "./CajaList.vue?vue&type=style&index=0&id=5a43e5d0&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a43e5d0"]])

export default __exports__